
/**
 * This class makes the 'show more' button work on the homepage
 * This way we can add a  lot of extra text to the homepage while hiding part of it
 * until the user clicks 'show more'.
 *
 * @export
 * @class HomeIntro
 */
export default class HomeIntro {

  introElem:HTMLElement = null;
  introMoreElem:HTMLCollectionOf<Element> = null;
  moreBtn:HTMLElement = null;

  constructor() {
    this.introElem = document.getElementById("home_intro");
    this.introMoreElem = document.getElementsByClassName("home_intro_more");
    this.moreBtn = document.getElementById("home_intro_more_btn");

    if(this.moreBtn == null) throw Error("Invalid ID given");


    this.moreBtn.addEventListener("click", this.onMoreClick.bind(this));
  }

  onMoreClick(e:MouseEvent) {
    e.preventDefault();

    Array.prototype.forEach.call(this.introMoreElem, function(el){
      el.style.display = "block";
    });

    this.moreBtn.style.display = "none";
  }

}
